export const buttonSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;

export type ButtonSize = typeof buttonSizes[number];
